/** Constants related to analytics tracking and data collection */

// Key for storing search term data in sessionStorage
export const SEARCH_TERMS_DATA_KEY = "SEARCH_TERMS_DATA";

// Search terms type for analytics tracking
export enum SearchTermsType {
  TYPEAHEAD = "typeahead",
  MANUAL_SEARCH = "manual-search",
  TRENDING_SEARCH_TERM = "trending-search-term",
  PREVIOUS_SEARCH_TERM = "previous-search-term",
}
